// VITRINA/фронтед/src/pages/Profile/Invite.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Copy, Check, Loader2 } from 'lucide-react';
import QRCode from 'react-qr-code';

const Invite = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [referralLink, setReferralLink] = useState('');
  
  // CHANGED: Раздельные стейты для бонусов
  const [friendBonus, setFriendBonus] = useState(300); // Сколько получит друг
  const [myBonus, setMyBonus] = useState(300);         // Сколько получу я
  
  const [copied, setCopied] = useState(false);
  
  const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
  const currentUserId = tgUser?.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!currentUserId) return;
        const res = await axios.get(`/api/profile?user_id=${currentUserId}`);
        if (res.data) {
          if (res.data.referral_link) {
            setReferralLink(res.data.referral_link);
          }
          // CHANGED: Заполняем раздельные значения
          if (res.data.referral_welcome_bonus) {
            setFriendBonus(res.data.referral_welcome_bonus);
          }
          if (res.data.referral_reward_bonus) {
            setMyBonus(res.data.referral_reward_bonus);
          }
        }
      } catch (e) {
        console.error("Error fetching referral data:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentUserId]);

  const handleCopy = () => {
    if (referralLink) {
      navigator.clipboard.writeText(referralLink).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  };

  if (loading) return (
    <div className="min-h-screen bg-tg-bg flex items-center justify-center">
        <Loader2 className="animate-spin text-tg-hint" />
    </div>
  );

  return (
    <div className="min-h-screen bg-tg-bg text-tg-text pb-32">
      {/* Header */}
      <div className="px-4 pb-4 pt-tg flex items-center sticky top-0 bg-tg-bg/95 backdrop-blur-md z-10">
        <button onClick={() => navigate('/profile')} className="mr-3 p-1 active:opacity-60 text-tg-text">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-xl font-bold">Пригласить друга</h1>
      </div>

      <div className="p-6 flex flex-col items-center text-center">
        {/* CHANGED: Используем переменную бонуса друга в заголовке */}
        <h2 className="text-2xl font-bold mb-2">Дарим {friendBonus} ₽</h2>
        <p className="text-tg-hint mb-8 text-sm px-4">
          {/* CHANGED: Точная формулировка с двумя разными переменными */}
          Отправьте эту ссылку другу. Он получит {friendBonus} бонусов на первый заказ, а вы — {myBonus} бонусов после его покупки.
        </p>

        {/* QR Code Container */}
        <div className="bg-white p-4 rounded-2xl mb-8 shadow-sm">
          {referralLink && (
            <QRCode 
              value={referralLink} 
              size={200}
              bgColor="#FFFFFF"
              fgColor="#000000"
            />
          )}
        </div>

        {/* Link Text Box */}
        <div className="w-full bg-tg-secondary-bg p-3 rounded-xl mb-4 flex items-center justify-center border border-transparent">
            <span className="text-xs text-tg-hint break-all font-mono selection:bg-blue-200">
              {referralLink}
            </span>
        </div>

        {/* Кнопка Копировать */}
        <button 
          onClick={handleCopy}
          className={`w-full py-3.5 rounded-xl font-bold text-white flex items-center justify-center gap-2 transition-all active:scale-95 shadow-md ${copied ? 'bg-green-500' : 'bg-blue-500'}`}
        >
          {copied ? <Check size={20} /> : <Copy size={20} />}
          {copied ? 'Скопировано' : 'Копировать ссылку'}
        </button>

      </div>
    </div>
  );
};

export default Invite;
